<template>
    <div class="warning-panel" v-if="warnings && warnings.length">
        <div class="warning-header">
            <div class="warning-title">Cảnh báo</div>
            <div class="warning-date">{{ currentMonthYear }}</div>
        </div>
        <ul class="warning-list">
            <li v-for="w in warnings" :key="w.user_id">
                <span class="dot"></span>
                <div class="text">
                    <div class="user">{{ w.user_name }}</div>
                    <div class="desc">{{ w.message }}</div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'WarningPanel',
    props: {
        warnings: { type: Array, required: true },
    },
    computed: {
        currentMonthYear() {
            const now = new Date();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const year = now.getFullYear();
            return `${month}-${year}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.warning-panel {
    position: absolute;
    top: 80px;
    right: 20px;
    width: 400px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    padding: 20px;
    height: 250px;
}

.warning-header {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
}

.warning-title {
    font-weight: 700;
    color: #4d1eab;
    margin: 0 0 4px 0;
    font-size: 16px;
}

.warning-date {
    color: #6b7280;
    font-size: 12px;
    margin-left: 0;
}

.warning-list {
    list-style: none;
    padding: 0;
    margin: 0;
    position: relative;
}

.warning-list::before {
    content: '';
    position: absolute;
    left: 8px;
    top: 0;
    bottom: 0;
    width: 2px;
    background: #c4b5fd;
}

.warning-list li {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 0;
    position: relative;
}

.warning-list .view-detail {
    margin-left: auto;
    cursor: pointer;
    color: #6b7280;
    font-size: 16px;
    padding: 4px;
    border-radius: 4px;
    transition: all 0.2s ease;
    margin-top: 4px;
}

.warning-list .view-detail:hover {
    color: #4d1eab;
    background-color: #f3f4f6;
}

.warning-list .dot {
    width: 12px;
    height: 12px;
    background: #8b5cf6;
    border-radius: 50%;
    margin-top: 15px;
    border: 2px solid #fff;
    box-shadow: 0 0 0 2px #c4b5fd;
    z-index: 1;
}

.warning-list .text {
    flex: 1;
}

.warning-list .user {
    font-weight: 600;
    color: #374151;
    margin-bottom: 4px;
    font-size: 14px;
}

.warning-list .desc {
    color: #6b7280;
    font-size: 13px;
    line-height: 1.4;
}
</style>


